// WallColorSchemaTable.jsx — reference table shown under the Coloured Zone
// canvas in its edit view (the same data is drawn into the PDF right after the
// Coloured Zone page). It sits OUTSIDE the Konva stage, so it never ends up
// inside the captured zone image.
import React from 'react';
import { WALL_COLORS, WALL_COLOR_ROWS, wallLabel, wallColorLabel } from './WallColorSchemaData';

const Cell = ({ cell, lang }) => (
  <>
    {cell.map((group, gi) => (
      <span key={gi} style={{ marginRight: '6px', display: 'inline-block' }}>
        {group.map((key, ki) => (
          <React.Fragment key={key}>
            {ki > 0 && <span style={{ color: '#6b7280' }}> / </span>}
            <span style={{ color: WALL_COLORS[key].hex, fontWeight: 600 }}>{wallColorLabel(key, lang)}</span>
          </React.Fragment>
        ))}
      </span>
    ))}
  </>
);

export default function WallColorSchemaTable({ language = 'en', width = 794 }) {
  const th = { padding: '10px 8px', color: '#fff', fontSize: '12px', fontWeight: 700, textAlign: 'center', border: '1px solid #ffffff55' };
  const td = { padding: '8px 10px', fontSize: '12px', lineHeight: 1.5, border: '1px solid #e5e7eb', verticalAlign: 'middle', textAlign: 'center' };
  return (
    <div style={{ width, marginTop: '20px', color: '#111', fontFamily: "'Noto Sans','Nirmala UI',Arial,sans-serif" }}>
      <h3 style={{ textAlign: 'center', margin: '0 0 12px', color: '#7f0000', fontSize: '16px' }}>
        {wallLabel('title', language)}
      </h3>
      <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed', background: '#fff' }}>
        <colgroup>
          <col style={{ width: '14%' }} /><col style={{ width: '25%' }} /><col style={{ width: '31%' }} /><col style={{ width: '30%' }} />
        </colgroup>
        <thead>
          <tr style={{ background: '#800000' }}>
            <th style={th}>{wallLabel('colorZone', language)}</th>
            <th style={th}>{wallLabel('favorable', language)}</th>
            <th style={th}>{wallLabel('anti', language)}</th>
            <th style={th}>{wallLabel('possible', language)}</th>
          </tr>
        </thead>
        <tbody>
          {WALL_COLOR_ROWS.map((row, i) => (
            <tr key={row.zone} style={{ background: i % 2 ? '#f9fafb' : '#fff' }}>
              <td style={{ ...td, fontWeight: 700, color: WALL_COLORS[row.zone].hex }}>{wallColorLabel(row.zone, language)}</td>
              <td style={td}><Cell cell={row.favorable} lang={language} /></td>
              <td style={td}><Cell cell={row.anti} lang={language} /></td>
              <td style={td}><Cell cell={row.possible} lang={language} /></td>
            </tr>
          ))}
        </tbody>
      </table>
      <p style={{ fontSize: '12px', margin: '12px 0 4px', color: '#111' }}>{wallLabel('note1', language)}</p>
      <p style={{ fontSize: '12px', margin: '4px 0 0', color: '#111' }}>{wallLabel('note2', language)}</p>
    </div>
  );
}
